import Request from './request'

const Device_Massive_Rpc = {
  getMassRPCIndex (callback) {
    Request.get('device-massive-rpc/index').then(callback).catch(this.bad_answer)
  },
  runMassRPCCommand (params, callback) {
    Request.post('device-massive-rpc/run', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getMassRPCCommand (callback) {
    Request.get('device-massive-rpc/commands').then(callback).catch(this.bad_answer)
  },
}
export default Device_Massive_Rpc
